import React from "react";
import { connect } from "react-redux";
import { setCurrentPage, getUsersThunk, getFollow, getUnFollow } from "../../redux/users-reducer";
import Users from './Users'
import Preloader from "../../common/Preloader/Preloader";
import { compose } from "redux";
import { getCurrentPage, getPortionSize, getFollowingInProgress, getIsFetching, getPageSize, getTotalUsersCount, getUserSuper } from "../../redux/users-selectors";

class UsersContainer extends React.Component {

  componentDidMount() {
    let { currentPage, pageSize } = this.props
    this.props.getUsersThunk(currentPage, pageSize)
  }

  getUsers = (currentPage) => {
    let { pageSize } = this.props
    this.props.getUsersThunk(currentPage, pageSize)
  }

  render() {
    let { isFetching } = this.props
    return <>
      {isFetching ? <Preloader /> : null}
      <Users {...this.props} getUsers={this.getUsers} />
    </>
  }
}

let mapStateToProps = (state) => {
  return ({
    users: getUserSuper(state),
    pageSize: getPageSize(state),
    portionSize: getPortionSize(state),
    totalUsersCount: getTotalUsersCount(state),
    currentPage: getCurrentPage(state),
    isFetching: getIsFetching(state),
    followingInProgress: getFollowingInProgress(state),
  })
}

export default compose(
  connect(mapStateToProps, { setCurrentPage, getUsersThunk, getFollow, getUnFollow }),
)(UsersContainer);